import { Injectable } from '@angular/core'
import { Logger } from '../../logger.service'
import * as Excel from 'exceljs/dist/exceljs.min.js'
import * as fs from 'file-saver'
import { AuthService } from '../general/auth.service'
import { HMPGlobal } from '../../config/HMPGlobal'
const log = new Logger('GuestExportDatabaseService')
import * as _moment from 'moment'
const moment = _moment
declare const ExcelJS: any
@Injectable({ providedIn: 'root' })
export class GuestExportDatabaseService {
  constructor(private auth: AuthService) {}

  private getCurrencyInfo() {
    const currency = this.auth.getCurrentCurrency()
    return HMPGlobal.getCurrency(currency)
  }

  onGenerateReportExcel(title, data: any[], sheetname, filename, searchVal) {
    const headerRow1Columns = [
      '',
      'Name(Last, First)',
      'Gender',
      'Country of Residence',
      'Email',
      'Phone Number',
      'Total Spending',
      'Reservations',
      'Nights Stayed',
      'Tags',
      'Notes',
    ]

    let workbook = new Excel.Workbook()
    workbook.creator = 'HMP'
    workbook.lastModifiedBy = 'HMP'
    workbook.created = new Date()
    workbook.modified = new Date()
    workbook.lastPrinted = new Date()

    let worksheet = workbook.addWorksheet(sheetname, {
      properties: {
        tabColor: { argb: 'FFFFFF00' },
        showGridLines: true,
        defaultRowHeight: 20,
      },
      views: [{ state: 'normal', showGridLines: true }],
    })

    // COLUMN WIDTH
    worksheet.columns = [
      { key: 'C0', width: 7 },
      { key: 'C1', width: 30 },
      { key: 'C2', width: 30 },
      { key: 'C3', width: 30 },
      { key: 'C4', width: 30 },
      { key: 'C5', width: 20 },
      { key: 'C6', width: 30 },
      { key: 'C7', width: 30 },
      { key: 'C8', width: 30 },
      { key: 'C9', width: 30 },
      { key: 'C10', width: 50 },
    ]

    // TITLE ROW 0,1,2
    worksheet.addRow([])
    worksheet.addRow([])
    worksheet.addRow([])
    let titleText = `${title}`
    let titleRow = worksheet.addRow([' ', titleText])
    worksheet.mergeCells('B4:K4')
    let titleCell = worksheet.getCell('B4')
    titleCell.font = {
      name: 'Calibri',
      family: 4,
      size: 12,
      bold: true,
    }
    titleCell.border = {
      bottom: { style: 'medium' },
    }
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' }

    titleRow.height = 20

    let showmatching = worksheet.addRow([])
    showmatching.font = {
      name: 'Calibri',
      size: 10,
      bold: false,
    }
    showmatching.alignment = { horizontal: 'left', vertical: 'middle' }
    showmatching.getCell(2).value = 'Showing Guests Matching ...'
    showmatching.getCell(2).font = {
      name: 'Calibri',
      size: 10,
      bold: false,
    }
    let sumRowHeader = worksheet.addRow([])
    sumRowHeader.font = {
      name: 'Calibri',
      size: 10,
      bold: false,
    }
    sumRowHeader.alignment = { horizontal: 'left', vertical: 'middle' }
    sumRowHeader.getCell(2).value = `Country of Residence: ${searchVal.country}`
    sumRowHeader.getCell(2).font = {
      name: 'Calibri',
      size: 10,
      bold: false,
    }
    let sumRowValue = worksheet.addRow([])
    sumRowValue.alignment = { horizontal: 'left', vertical: 'middle' }
    sumRowValue.font = {
      name: 'Calibri',
      size: 10,
      bold: false,
    }
    sumRowValue.getCell(2).value = `Tags: ${searchVal.tag}`

    worksheet.addRow([])

    let headerRow1 = worksheet.addRow(headerRow1Columns)
    headerRow1.font = {
      name: 'Calibri',
      size: 10,
      bold: true,
    }
    headerRow1.eachCell((cell, number) => {
      if (number > 1) {
        cell.border = {
          top: { style: 'thin' },
          bottom: { style: 'medium' },
        }
        cell.alignment = { horizontal: 'center', vertical: 'middle' }
      }
    })
    headerRow1.height = 20

    for (let index = 0; index < data.length; index++) {
      const r = data[index]
      let dataRowColumn = this.generateProductionReportColumnArr(r)
      let dataRow = worksheet.addRow(dataRowColumn)
      dataRow.font = {
        name: 'Calibri',
        size: 10,
        bold: false,
      }
      dataRow.height = 17
      dataRow.alignment = { horizontal: 'center', vertical: 'middle' }
      dataRow.getCell(2).alignment = { horizontal: 'left' }
      // dataRow.getCell(2).numFmt = 'DD-MMM-YY'
      dataRow.getCell(3).alignment = { horizontal: 'left' }
      dataRow.getCell(4).numFmt = '#,##0.00'
      dataRow.getCell(4).alignment = { horizontal: 'left' }
      dataRow.getCell(5).alignment = { horizontal: 'left' }
      dataRow.getCell(6).alignment = { horizontal: 'left' }
      dataRow.getCell(7).alignment = { horizontal: 'right' }
      dataRow.getCell(7).numFmt = '#,##0.00'
      dataRow.getCell(8).alignment = { horizontal: 'center' }
      dataRow.getCell(9).alignment = { horizontal: 'center' }
      dataRow.getCell(10).alignment = { horizontal: 'left' }
      dataRow.getCell(11).alignment = { horizontal: 'left' }
    }

    workbook.xlsx.writeBuffer().then(data => {
      let blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      fs.saveAs(blob, filename + '.xlsx')
    })
  }

  private generateProductionReportColumnArr(data) {
    let row = []
    row.push('')
    row.push(data.name)
    row.push(data.gender)
    row.push(data.country)
    row.push(data.email)
    row.push(data.phone)
    row.push(data.total_spending)
    row.push(data.reservation)
    row.push(data.night_stayed)
    row.push(data.tag)
    row.push(data.note)
    return row
  }

  private getImageDimensions(file): Promise<any> {
    return new Promise(function(resolved, rejected) {
      var i = new Image()
      i.onload = function() {
        resolved({ w: i.width, h: i.height })
      }
      i.src = file
    })
  }
}
